export default "__VITE_ASSET__812605d1__"